import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../api";
import { energyDataApiWithoutCamelization } from "../../api/subApis/energyDataApi";
import type { EnergyDataWarning } from "../../components/EnergyData/EnergyDataView/EnergyDataView.types";

function useEnergyDataWarnings(variantId: number) {
  return useQuery({
    queryFn: fetchEnergyDataWarnings,
    queryKey: energyDataApiWithoutCamelization.warnings.key({ variantId })
  });

  async function fetchEnergyDataWarnings() {
    const response = await apiWithoutCamelization.get<EnergyDataWarning>(
      energyDataApiWithoutCamelization.warnings.url({ variantId })
    );
    return response.data;
  }
}

export { useEnergyDataWarnings };
